export const isThereOnlyFalsyValueInObject = obj => Object.entries(obj).every(([_key, value]) => !value);
